import { createRoute } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { Overview as TeamsOverview } from 'domains/Organizations/Organization/TeamManagement/Team/Teams'
import { Overview as PeopleOverview } from 'domains/Organizations/Organization/TeamManagement/Team/Users'
import { teamsRoute } from 'pages/NWPlatform/Organizations/Organization/Teams'
import { Structure } from 'pages/NWPlatform/Organizations/Organization/Teams/Team/Structure'

export const teamRoute = createRoute({
  getParentRoute: () => teamsRoute,
  path: DynamicRouteParameterWPrefix.TEAM_ID,
})

export const teamLayoutRoute = createRoute({
  getParentRoute: () => teamRoute,
  id: 'teamLayout',
  component: Structure,
})

type MembersSearch = {
  query?: string
}

export const membersOverviewRoute = createRoute({
  getParentRoute: () => teamLayoutRoute,
  path: StaticRouteParameter.MEMBERS,
  component: PeopleOverview,
  validateSearch: (search: Record<string, unknown>): MembersSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

type TeamsSearch = {
  query?: string
}

export const teamOverviewRoute = createRoute({
  getParentRoute: () => teamLayoutRoute,
  path: StaticRouteParameter.TEAMS,
  component: TeamsOverview,
  validateSearch: (search: Record<string, unknown>): TeamsSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})
